import React, { useContext, useEffect, useState } from 'react';
import useForm from 'react-hook-form';
import styled from '@emotion/styled';
import { TextInput, EmailInput } from 'dw-au-react-components';
import { CartContext } from '../../../Context/CartContext';
import { CloseIcon } from '../../../svg';

const StyledAddressForm = styled.form`
	button {
		height: 56px;
	}
`;

function VoucherPopupForm({ toggleModal }) {
	const { addCouponCode, removeCouponCode, couponCode, setVoucherPopupEmail } =
		useContext(CartContext);
	const [showCloseBtn, setShowCloseBtn] = useState(false);
	const [couponCodeValue, setCouponCodeValue] = useState('');

	const { register, errors, handleSubmit } = useForm({
		mode: 'onBlur',
		defaultValues: {
			couponCode: couponCode,
		},
	});

	useEffect(() => {
		if (couponCode) {
			setCouponCodeValue(couponCode);
			setShowCloseBtn(true);
		}
	}, []);

	const handleOnChange = (e) => {
		let voucherValue = e.target.value;

		if (voucherValue.length >= 0) {
			setCouponCodeValue(voucherValue);
			// addCouponCode(voucherValue);
			setShowCloseBtn(true);
		} else {
			setShowCloseBtn(false);
			removeCouponCode();
		}
	};

	const handleOnClick = () => {
		setCouponCodeValue('');
		removeCouponCode();
		setShowCloseBtn(false);
	};

	const handleFormSubmission = ({ email }) => {
		if (email) {
			setVoucherPopupEmail(email);
		}
		toggleModal();
	};

	return (
		<StyledAddressForm
			onSubmit={handleSubmit((data) => handleFormSubmission(data))}
		>
			<div className='d-sm-flex align-items-start justify-content-center flex-equal'>
				<div className='m-10'>
					<EmailInput register={register} errors={errors} />
				</div>
				<div className='m-10'>
					<TextInput
						type='text'
						label='Enter coupon code'
						name='couponCode'
						maxLength={10}
						register={register({ required: 'Coupon code is required' })}
						helperText={errors?.couponCode ? 'Coupon code is required' : ''}
						error={errors?.couponCode ? true : false}
						icon={
							showCloseBtn ? (
								<CloseIcon onClick={handleOnClick} className='cursor-pointer' />
							) : null
						}
						onChange={handleOnChange}
						value={couponCodeValue}
					/>
				</div>
				<div className='m-10'>
					<button
						type='submit'
						className={'btn btn-primary font-weight-bold w-100 mb-20'}
					>
						Redeem Voucher
					</button>
				</div>
			</div>
		</StyledAddressForm>
	);
}

export default VoucherPopupForm;
